// also required mixins/ThoughtListMixins.js to add emitters to component
export default function useThoughtEvents(context: any) {
  function emitOpenThought(thoughtid: number, topicid: number, actions = {}) {
    context.emit('open-thought', thoughtid, topicid, actions);
  }
  function emitEditThought(thoughtid: number, topicid: number) {
    context.emit('edit-thought', thoughtid, topicid);
  }
  function emitCloseThought(params: {}) {
    context.emit('close-thought', params);
  }
  function emitCancelThoughtForm() {
    context.emit('cancel-thought-form');
  }
  function emitCreateThought() {
    context.emit('create-thought');
  }
  function emitSetMapCenter(location: object) {
    context.emit('set-map-center', location);
  }
  function emitFeedbackMessage(message: object) {
    context.emit('feedback-thought', message);
  }
  function emitVoteValue(event: object, nbr: number) {
    context.emit('vote-value', event, nbr);
  }

  return {
    emitOpenThought,
    emitEditThought,
    emitCloseThought,
    emitCreateThought,
    emitSetMapCenter,
    emitCancelThoughtForm,
    emitFeedbackMessage,
    emitVoteValue,
  };
}
